import { createSlice, PayloadAction } from '@reduxjs/toolkit';
interface IViewModeState {
    viewMode: 'pc' | 'tablet' | 'mobile';
}
const initialState: IViewModeState = {
    viewMode: 'pc',
};
const viewModeSlice = createSlice({
    name: 'viewMode',
    initialState,
    reducers: {
        setViewMode: (
            state,
            action: PayloadAction<'pc' | 'tablet' | 'mobile'>
        ) => {
            // console.log(action.payload);
            state.viewMode = action.payload;
        },
    },
});

export const { setViewMode } = viewModeSlice.actions;

export default viewModeSlice.reducer;
